import { createFrame } from '@shared/iFrameHandler/createFrame';

export const openIframe = (
  iFrameUrl: string,
  iFrameId: string,
  isSrcDocUsed: boolean,
) => {
  if (document.body) {
    const wrapper: HTMLDivElement = document.body.appendChild(
      document.createElement('div'),
    );
    wrapper.style.position = 'absolute';
    wrapper.style.top = '0';
    wrapper.style.left = '0';
    wrapper.style.width = '1px';
    wrapper.style.height = '1px';
    wrapper.style.display = 'none';
    const iFrame: HTMLIFrameElement = createFrame(
      iFrameUrl,
      iFrameId,
      isSrcDocUsed,
    );
    wrapper.appendChild(iFrame);
    return iFrame;
  }
};
